import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "laclive-cookie-notice-ack-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        // Delay slightly to not compete with initial page paint
        const t = setTimeout(() => setVisible(true), 400);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, new Date().toISOString()); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-50 animate-in fade-in slide-in-from-bottom-4 duration-300"
      role="dialog"
      aria-live="polite"
      aria-label="Hinweis zu Cookies"
      data-testid="cookie-banner"
    >
      <div className="bg-white rounded-2xl shadow-[0_20px_50px_-15px_rgba(15,23,42,0.25)] border border-slate-200 p-5 relative">
        <button
          onClick={dismiss}
          className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 p-1 rounded-md hover:bg-slate-100"
          aria-label="Schließen"
          data-testid="cookie-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-emerald-700" />
          </div>
          <div className="flex-1 min-w-0 pr-4">
            <h3 className="font-semibold text-slate-900 text-sm">Nur technisch notwendige Cookies</h3>
            <p className="text-xs text-slate-600 mt-1.5 leading-relaxed">
              LacLive verwendet ausschließlich einen technisch notwendigen Cookie für die Anmeldung (HttpOnly-JWT). Keine Tracker, keine Werbung, keine externen Analyse-Dienste. Diese Cookies sind gemäß § 25 Abs. 2 Nr. 2 TDDDG einwilligungsfrei.
            </p>
            <div className="flex items-center gap-3 mt-3.5">
              <Button
                onClick={dismiss}
                className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white h-9 px-4 text-sm btn-lift"
                data-testid="cookie-banner-accept"
              >
                Verstanden
              </Button>
              <Link
                to="/datenschutz"
                onClick={dismiss}
                className="text-xs text-emerald-700 hover:text-emerald-800 hover:underline"
                data-testid="cookie-banner-privacy"
              >
                Datenschutz &rarr;
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
